namespace TabAurous.Production {
    export interface MFGTransactionLossForm {
        TransItemId: Serenity.StringEditor;
        TransId: Serenity.StringEditor;
        ProductId: Serenity.StringEditor;
        BomProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        Line_No: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: Serenity.DecimalEditor;
        FromDeptId: Serenity.IntegerEditor;
        ToDeptId: Serenity.IntegerEditor;
        FromWorkerId: Serenity.IntegerEditor;
        ToWorkerId: Serenity.IntegerEditor;
        RefVoucherId: Serenity.IntegerEditor;
        RefTransId: Serenity.StringEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransBomId: Serenity.StringEditor;
    }

    export class MFGTransactionLossForm extends Serenity.PrefixedContext {
        static formKey = 'Production.MFGTransactionLoss';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MFGTransactionLossForm.init)  {
                MFGTransactionLossForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(MFGTransactionLossForm, [
                    'TransItemId', w0,
                    'TransId', w0,
                    'ProductId', w0,
                    'BomProductId', w0,
                    'AttributeId', w0,
                    'BagNo', w0,
                    'Line_No', w0,
                    'Pieces', w1,
                    'Weight', w2,
                    'Purity', w2,
                    'PureWeight', w2,
                    'FromDeptId', w1,
                    'ToDeptId', w1,
                    'FromWorkerId', w1,
                    'ToWorkerId', w1,
                    'RefVoucherId', w1,
                    'RefTransId', w0,
                    'RefTransItemId', w0,
                    'RefTransBomId', w0
                ]);
            }
        }
    }
}
